"use strict"

import {
  IDocumentService,
  ILocationService,
  ILogService,
  IQService,
  IRootScopeService,
  IScope,
  IWindowService,
} from "angular"
import { StateParams, StateService } from "angular-ui-router"
import * as angular from "angular"

import {
  AppConfiguration,
  DEFAULT_ASSIGNMENT_LIMIT,
  DEFAULT_STUDENT_PAGES_LIMIT,
} from "../../app/model/domain/app-configuration"
import Contract from "../../app/model/domain/contract"
import Organization from "../../app/model/domain/organization"
import Subscription, {
  SubscriptionTiers,
} from "../../app/model/domain/subscription"
import User, {
  UsageProperties,
  UserProperties,
} from "../../app/model/domain/user"

import Debouncer from "../../app/model/util/debouncer"
import SaveStates from "../../app/components/saving-indicator/save-states"
import LoadingDialogController from "../../app/components/loading-dialog/loading-dialog.controller"
import AuthService, { AuthType } from "../../app/services/auth/auth.service"
import Validation from "../../app/model/util/validation"
import ConfirmDialogController from "../../app/components/confirm-dialog/confirm-dialog.controller"
import NavController from "../../app/controllers/nav/nav.controller"
import DeleteAccountDialogController from "../../app/components/delete-account-dialog/delete-account-dialog.controller"
import UpdateUserSchoolDialogController from "../../app/components/update-user-school-dialog/update-user-school-dialog.controller"
import AssignmentsLimitPaywallDialogController from "../../app/components/assignments-limit-paywall-dialog/assignments-limit-paywall-dialog.controller"
import CancelSubscriptionDialogController from "../../app/components/cancel-subscription-dialog/cancel-subscription-dialog.controller"
import ErrorDialogController from "../../app/components/error-dialog/error-dialog.controller"
import SelectMdrOrgDialogController from "../../app/components/select-mdr-org-dialog/select-mdr-org-dialog.controller"
import Sorts from "../../app/model/domain/sorts"
import { Locations } from "../../app/services/mixpanel/mixpanel.service"
import { ABTest } from "../../app/services/ab-test/ab-test-service"
import { OrderManager } from "../../app/model/domain/order-manager"
import CacheService from "../../app/services/cache/cache.service"
import StudentCacheService from "../../app/services/student-cache/student-cache.service"
import InviteCodeService from "../../app/services/invite-code/invite-code.service"
import SubscriptionService from "../../app/services/subscription/subscription.service"
import BreadcrumbService from "../../app/services/breadcrumb-service/breadcrumb.service"
import OrganizationService from "../../app/services/organization/organization.service"
import StaticContentService from "../../app/services/static/static-content.service"
import LogRocketService from "../../app/services/log-rocket/log-rocket.service"
import UserService from "../../app/services/user/user.service"
import StorageService from "../../app/services/storage/storage.service"
import OrderService from "../../app/services/order/order.service"
import ContractService from "../../app/services/contract/contract.service"

type SchoolWithAdmins = Organization & {
  adminMembers?: User[]
}

interface BannerInfo {
  showBanner: boolean
}

export class StudentProfileController {
  private $q: IQService
  private $location: ILocationService
  private $scope: IScope
  private $rootScope: IRootScopeService
  private $state: StateService
  private $stateParams: StateParams
  private $mdSidenav: angular.material.ISidenavService
  private $window: IWindowService
  private $log: ILogService
  private $mdToast: angular.material.IToastService
  private $mdDialog: angular.material.IDialogService
  private $document: IDocumentService

  private _cacheService: CacheService
  private _studentCacheService: StudentCacheService
  private _authService: AuthService
  private _inviteCodeService: InviteCodeService
  private _subscriptionService: SubscriptionService
  private _breadcrumbService: BreadcrumbService
  private _organizationService: OrganizationService
  private _staticContentService: StaticContentService
  private _logRocketService: LogRocketService
  private _userService: UserService
  private _storageService: StorageService
  private _orderService: OrderService
  private _orderManager: OrderManager

  private _loadingDialog: any
  private _confirmDialog: any
  private _deleteAccountDialog: any
  private _mdrOrgDialog: any
  private _updateUserSchoolDialog: (...args: any[]) => Promise<any>
  private _assignmentsLimitPaywallDialog: any
  private _cancelSubscriptionDialog: any
  private _errorDialog: any

  private _state: string
  public saveState: string | null
  public prefixOptions: string[]
  public jobTitleOptions: string[]
  public subjectOptions: string[]
  public studentAgeOptions: string[]
  public referralOptions: string[]
  private _usageConfig: any
  private _appConfig: AppConfiguration | null = null
  private _user: User | null = null
  private _contracts: Contract[] | null = null
  private _subscriptions: Subscription[] | null = null
  private _schools: SchoolWithAdmins[] | null = null
  private _unverifiedSchools: Map<string, Organization> | null = null
  private _assignmentsUsedCount = 0
  private _teacherUsageStats: any
  private _inviteCodePattern: string
  private _inviteCodeRegex: RegExp
  private _inviteCode = ""
  private _inviteCodeError = false
  private _loading = true
  private _debouncer!: Debouncer
  private _proInfo: any
  private _anonBeforeUnload!: (event: BeforeUnloadEvent) => void

  public oldPassword = ""
  public newPassword = ""
  public prefix: string | null = null
  public firstName: string | null = null
  public lastName: string | null = null
  public username: string | null = null
  public email: string | null = null
  public jobTitle: string | null = null
  public referral: string | null = null
  public studentAge: string | null = null
  public subject: string | null = null
  public _usernameError: string | null = null
  public _emailError: string | null = null
  private _addedNewPassword = false
  public isTeamButtonAccessDisabled = false
  public isAssignmentLimit20Segment: boolean | undefined
  public error: any
  public showNewPassword = false

  constructor(
    $q: IQService,
    $location: ILocationService,
    $state: StateService,
    $stateParams: StateParams,
    $scope: IScope,
    $rootScope: IRootScopeService,
    AuthService: AuthService,
    $mdSidenav: angular.material.ISidenavService,
    $window: IWindowService,
    $log: ILogService,
    $mdToast: angular.material.IToastService,
    $mdDialog: angular.material.IDialogService,
    $document: IDocumentService,
    CacheService: CacheService,
    StudentCacheService: StudentCacheService,
    InviteCodeService: InviteCodeService,
    SubscriptionService: SubscriptionService,
    BreadcrumbService: BreadcrumbService,
    OrganizationService: OrganizationService,
    StaticContentService: StaticContentService,
    LogRocketService: LogRocketService,
    UserService: UserService,
    StorageService: StorageService,
    OrderService: OrderService,
  ) {
    "ngInject"

    this.$q = $q
    this.$location = $location
    this.$scope = $scope
    this.$rootScope = $rootScope
    this.$state = $state
    this.$stateParams = $stateParams
    this.$mdSidenav = $mdSidenav
    this.$window = $window
    this.$log = $log
    this.$mdToast = $mdToast
    this.$mdDialog = $mdDialog
    this.$document = $document

    this._cacheService = CacheService
    this._studentCacheService = StudentCacheService
    this._authService = AuthService
    this._inviteCodeService = InviteCodeService
    this._subscriptionService = SubscriptionService
    this._breadcrumbService = BreadcrumbService
    this._organizationService = OrganizationService
    this._staticContentService = StaticContentService
    this._logRocketService = LogRocketService
    this._userService = UserService
    this._storageService = StorageService
    this._orderService = OrderService

    this._orderManager = new OrderManager(
      $q,
      $log,
      undefined as any as ContractService,
      $mdDialog,
      $location,
      AuthService,
      OrderService,
      OrganizationService,
      BreadcrumbService,
      CacheService,
      undefined as any,
    )

    this._loadingDialog = LoadingDialogController.show
    this._confirmDialog = ConfirmDialogController.show
    this._deleteAccountDialog = DeleteAccountDialogController.show
    this._mdrOrgDialog = SelectMdrOrgDialogController.show

    this._state = this.$stateParams.tab || StudentProfileController.BasicInfoTab
    this.saveState = null

    this.prefixOptions = UserProperties.PREFIX_OPTIONS
    this.jobTitleOptions = UserProperties.JOB_TITLE_OPTIONS
    this.subjectOptions = UserProperties.SUBJECT_OPTIONS
    this.studentAgeOptions = UserProperties.STUDENT_AGE_OPTIONS
    this.referralOptions = UserProperties.REFERRAL_OPTIONS
    this._usageConfig = UsageProperties.USAGE_CONFIG

    this._inviteCodePattern = Validation.InviteCodePattern
    this._inviteCodeRegex = Validation.InviteCodeRegex

    this._updateUserSchoolDialog = UpdateUserSchoolDialogController.show
    this._assignmentsLimitPaywallDialog =
      AssignmentsLimitPaywallDialogController.show
    this._cancelSubscriptionDialog = CancelSubscriptionDialogController.show
    this._errorDialog = ErrorDialogController.show

    $scope.$on("$destroy", () => this._destroy())
    if ($window) {
      this._anonBeforeUnload = (event: BeforeUnloadEvent) =>
        this._onBeforeUnload()
    }

    this.init()
  }

  init() {
    this._loading = true
    this._debouncer = new Debouncer(
      3000,
      5000,
      () => {
        this._commit()
      },
      this.$scope,
      this.$window,
    )

    if (this.isACoTeacher()) {
      this._storageService.setUserInfoBackToCoTeacherAuth()
      if (this._authService.coTeacherAuthData) {
        this._authService
          .processTokenResult(
            this._authService.coTeacherAuthData.token,
            this._storageService.rememberMe,
          )
          .then(() => {
            this._initialUserProfileData()
          })
      }
    } else {
      return this._initialUserProfileData()
    }
  }

  _initialUserProfileData() {
    const teacherUsageStatsPromise = this._authService.authData
      ? this._userService.getTeacherUsageStats(this._authService.authData.id)
      : this.$q.resolve(null)

    this.$q
      .all({
        user: this._cacheService.getUser(true),
        proInfo: this._cacheService.getProInfo(),
        subscriptions: this._cacheService.getSubscriptions(),
        schools: this._cacheService.getSchools(),
        unverifiedSchools: this._cacheService.getUnverifiedOrganizations(true),
        assignmentLimit20Segment: this._cacheService.getTestSegment(
          ABTest.AssignmentLimit20,
        ),
        teacherUsageStats: teacherUsageStatsPromise,
      })
      .then(
        ({
          user,
          proInfo,
          subscriptions,
          schools,
          unverifiedSchools,
          assignmentLimit20Segment,
          teacherUsageStats,
        }: {
          user: User
          proInfo: any
          subscriptions: Subscription[]
          schools: Organization[]
          unverifiedSchools: Organization[]
          assignmentLimit20Segment: boolean
          teacherUsageStats: any
        }) => {
          this.user = user
          this._proInfo = proInfo
          this._contracts = proInfo.contracts
          this._subscriptions = subscriptions
          this._schools = this._getAdminsForSchools(schools)
          this._unverifiedSchools = new Map(
            unverifiedSchools.map((school) => [school.id, school]),
          )
          this.isAssignmentLimit20Segment = assignmentLimit20Segment
          this._teacherUsageStats = teacherUsageStats

          this._cacheService
            .getAppConfig()
            .then((config: AppConfiguration) => (this._appConfig = config))

          if (this.isTeacher && this._proInfo.isFree) {
            this._initPlans()
          }
          this._loading = false
        },
      )
      .catch((error) => {
        this.error = error
        this.$log.error(error.message)
        this._loading = false
      })
  }

  _initPlans() {
    this._cacheService
      .getAssignmentsForUser(false)
      .then((assignmentsMap: Map<string, any>) => {
        const assignments = Array.from(
          assignmentsMap,
          (tuple: [string, any]) => tuple[1],
        ).filter((assignment: any) => !assignment.isFolder)

        this._assignmentsUsedCount = assignments.length
      })
  }

  _onBeforeUnload() {
    this._commit()
  }

  get state() {
    return this._state
  }

  set state(value: string) {
    this._state = value
  }

  static get BasicInfoTab() {
    return "info"
  }

  static get SchoolTab() {
    return "school"
  }

  static get PlanTab() {
    return "plan"
  }

  get viewingInfo() {
    return this._state === StudentProfileController.BasicInfoTab
  }

  get viewingSchool() {
    return this._state === StudentProfileController.SchoolTab
  }

  get viewingPlan() {
    return this._state === StudentProfileController.PlanTab
  }

  goToProfileInfo() {
    if (this.$state.current.name) {
      this.$state.go(this.$state.current.name, {
        tab: StudentProfileController.BasicInfoTab,
      })
    }
    this._state = StudentProfileController.BasicInfoTab
  }

  goToProfileSchool() {
    if (this.$state.current.name) {
      this.$state.go(this.$state.current.name, {
        tab: StudentProfileController.SchoolTab,
      })
    }
    this._state = StudentProfileController.SchoolTab
  }

  goToProfilePlan() {
    if (this.$state.current.name) {
      this.$state.go(this.$state.current.name, {
        tab: StudentProfileController.PlanTab,
      })
    }
    this._state = StudentProfileController.PlanTab
  }

  goToProTeacherPayment() {
    const promise = this.$q.resolve()

    promise.then(() => {
      this._breadcrumbService.go("root.account.create-payment")
    })
  }

  get loading() {
    return this._loading
  }

  get assignmentsUsedCount() {
    return this._assignmentsUsedCount
  }

  get assignmentsLimit() {
    return (
      (this._appConfig && this._appConfig.assignmentLimit) ||
      DEFAULT_ASSIGNMENT_LIMIT
    )
  }

  get assignmentsUsedPercentage() {
    return this._calculateUsagePercentage(
      this.assignmentsUsedCount,
      this.assignmentsLimit,
    )
  }

  assignmentLimitText() {
    return this._generateLimitText(
      this.assignmentsUsedCount,
      this.assignmentsLimit,
      "assignment slots",
    )
  }

  _calculateUsagePercentage(used: number, limit: number) {
    if (!used || used <= 0) return 0
    return Math.round((used / limit) * 100)
  }

  _getUsageStatus(percentage: number) {
    for (const [status, config] of Object.entries(this._usageConfig)) {
      if (percentage < (config as any).threshold) {
        return status
      }
    }
    return "CRITICAL"
  }

  _generateLimitText(used: number, limit: number, itemType: string) {
    const remaining = limit - used

    if (remaining <= 0) {
      return `You have exceeded your ${limit.toLocaleString()} ${itemType}. Consider upgrading your plan.`
    }

    return `You have ${remaining.toLocaleString()} ${itemType} remaining.`
  }

  getProgressStatusClass(progress: number) {
    const status = this._getUsageStatus(progress)
    return this._usageConfig[status].class
  }

  getProgressStatusText(progress: number) {
    const status = this._getUsageStatus(progress)
    return this._usageConfig[status].text
  }

  get studentPagesUsedCount() {
    return this._teacherUsageStats?.pagesWorkedOnThisMonth || 0
  }

  get studentPagesLimit() {
    return DEFAULT_STUDENT_PAGES_LIMIT
  }

  get studentPagesUsedPercentage() {
    return this._calculateUsagePercentage(
      this.studentPagesUsedCount,
      this.studentPagesLimit,
    )
  }

  studentPagesLimitText() {
    return this._generateLimitText(
      this.studentPagesUsedCount,
      this.studentPagesLimit,
      "student pages",
    )
  }

  static get nextQuotaResetDate() {
    const nextMonth = new Date()
    nextMonth.setMonth(nextMonth.getMonth() + 1, 1)

    const month = nextMonth.toLocaleDateString("en-US", { month: "long" })
    return `${month} ${nextMonth.getDate()}`
  }

  get studentPagesResetMonth() {
    return StudentProfileController.nextQuotaResetDate
  }

  get hasExceededStudentPageLimit() {
    return this.studentPagesUsedPercentage >= 100
  }

  openAssignmentsLimitPaywallDialog() {
    return this._assignmentsLimitPaywallDialog(
      this.$mdDialog,
      this.assignmentsUsedCount,
      this.assignmentsLimit,
      Locations.PROFILE_PLAN,
    )
  }

  get showBanner() {
    const trialBanner = this._storageService.lastSeenTrialConversionBanner as
      | BannerInfo
      | undefined
    const renewalBanner = this._storageService
      .lastSeenRenewalConversionBanner as BannerInfo | undefined
    const assignmentBanner = this._storageService
      .lastSeenAssignmentNotificationBanner as BannerInfo | undefined

    return (
      (trialBanner && trialBanner.showBanner === true) ||
      (renewalBanner && renewalBanner.showBanner === true) ||
      (assignmentBanner && assignmentBanner.showBanner === true)
    )
  }

  get contracts() {
    return this._contracts
  }

  get activeContracts() {
    return this._contracts?.filter((contract) => !contract.isExpired) || []
  }

  get expiredContracts() {
    return this._contracts?.filter((contract) => contract.isExpired) || []
  }

  get hasContract() {
    return this._contracts && this.activeContracts.length === 1
  }

  get hasContracts() {
    return this._contracts && this.activeContracts.length > 1
  }

  get showTrialExplanationText() {
    return (
      this._contracts?.some(
        (contract) => contract.isTrial === true && !contract.isExpired,
      ) && this.isTeacher
    )
  }

  get subscriptions() {
    return this._subscriptions
  }

  isGrandfatheredPlan(contractId: string) {
    const subscription = this._subscriptions?.find(
      (sub) => sub.contractId === contractId,
    )
    if (
      subscription &&
      !SubscriptionTiers.some(
        (tier) => tier.id === subscription.subscriptionPlan,
      )
    ) {
      return true
    }
    return false
  }

  contractHasSubscription(contractId: string) {
    return this._subscriptions?.some(
      (subscription) =>
        subscription.contractId === contractId && subscription.active === true,
    )
  }

  updatePaymentInfo(contract: Contract) {
    const subscription = this._subscriptions?.find(
      (sub) => sub.contractId === contract.id,
    )
    if (subscription) {
      this._breadcrumbService.go("root.account.update-payment", {
        subscriptionPlan: subscription.subscriptionPlan,
      })
    }
  }

  cancelSubscription(contract: Contract) {
    const subscription = this._subscriptions?.find(
      (sub) => sub.contractId === contract.id,
    )

    if (!subscription || !this._user) return

    this._cancelSubscriptionDialog(
      this.$mdDialog,
      this._user,
      subscription,
      contract,
    ).then(() => {
      const promise = this._subscriptionService
        .cancel(subscription.id)
        .then(() => {
          return this._cacheService.getSubscriptions(true)
        })
        .then((subscriptions: Subscription[]) => {
          this._subscriptions = subscriptions
          this.showToast("Subscription cancelled")
        })
        .catch(() => {
          this._errorDialog(
            this.$mdDialog,
            "There was a problem canceling your subscription please reach out to support@classkick.com",
            "",
          )
        })

      this._loadingDialog(this.$mdDialog, promise)
    })
  }

  recurringStatusDisplay(contract: Contract) {
    if (contract.isExpired) {
      return `Expired ${contract.expiresDisplay}`
    } else if (contract.plan === "niagara") {
      if (this.contractHasSubscription(contract.id)) {
        return `Renews ${contract.subscriptionRenewsDisplay}`
      } else {
        return `Canceled. Expires ${contract.expiresDisplay}`
      }
    } else {
      return `Expires ${contract.expiresDisplay}`
    }
  }

  get schools() {
    return this._schools
  }

  get hasSchool() {
    return this._schools && this._schools.length > 0
  }

  get hasSchools() {
    return this._schools && this._schools.length > 1
  }

  changeSchool() {
    ;(
      this._updateUserSchoolDialog(
        this.$mdDialog,
        "Change Organization",
      ) as Promise<Organization>
    ).then((school: Organization) => this._changeSchool(school))
  }

  _changeSchool(school: Organization) {
    this.saveState = SaveStates.UNSAVED

    if (this._schools?.some((s) => s.id === school.id)) {
      this.saveState = SaveStates.SAVED
      return
    }

    const promise = this._leaveNonAdminSchools()
      .then(() => {
        return this._organizationService.addSelf(school.id)
      })
      .then((token) => {
        this._cacheService.reset()
        return this._authService.processTokenResult(
          token,
          this._authService.rememberMe,
        )
      })
      .then(() => {
        this.$state.reload()
      })
      .catch(() => {
        this.saveState = SaveStates.SAVE_ERROR
      })

    this._loadingDialog(this.$mdDialog, promise)
  }

  _leaveNonAdminSchools() {
    const nonAdminSchools =
      this._schools?.filter((school) => !school.contractId || !school.admin) ||
      []
    return this.$q.all(
      nonAdminSchools.map((school) =>
        this._organizationService.removeSelf(school.id),
      ),
    )
  }

  get user() {
    return this._user
  }

  set user(user: User | null) {
    if (user) {
      if (user.displayName && user.displayName.includes(" ")) {
        this.prefix = user.displayName.split(" ")[0]
      }
      this.firstName = user.firstName
      this.lastName = user.lastName
      this.username = user.username
      this.email = user.email
      this.jobTitle = user.jobTitle || null
      this.referral = user.referral || null
      this.studentAge = user.studentAge
      this.subject = user.subject || null
    }
    this._user = user
  }

  fieldUpdated(field: any, form: any, skip: boolean) {
    if (skip) return

    field.$touched = true
    const valid = form.$valid

    if (!this.email && !this.username) {
      this._emailError = this.isStudent
        ? "You must set an email or username"
        : "You must set an email"
      form.email.$setValidity("required", true)
    }

    this._debouncer.tick({})
    this._debouncer.valid = valid

    if (valid) {
      this.saveState = SaveStates.UNSAVED
    } else {
      this.saveState = SaveStates.SAVE_ERROR
    }
  }

  changePassword(form: any) {
    const promise = (
      this._authService.updatePassword(
        this.oldPassword,
        this.newPassword,
      ) as unknown as Promise<boolean>
    ).then((success) => {
      if (success) {
        this.showToast("Your password was updated successfully!")
        this.resetUpdatePasswordForm(form)
      } else {
        form.oldPassword.$setValidity("invalid-password", false)
      }
    })

    return this._loadingDialog(
      this.$mdDialog,
      promise,
      this.$document,
      ".user-profile .update-password-form",
    )
  }

  resetAddPasswordForm(form: any) {
    this.newPassword = ""
    this.showNewPassword = false
    form.newPassword.$setValidity("required", true)
    form.$setUntouched()
    form.$setPristine()
  }

  addPassword(form: any) {
    if (!this.user || !this.user.email) return
    const promise = this._userService
      .setPassword(this.user.email, this.newPassword)
      .then((success) => {
        if (success) {
          this.showToast("Your password was added successfully!")
          this.resetAddPasswordForm(form)
          this.addedNewPassword = true
        } else {
          form.newPassword.$setValidity("invalid-password", false)
        }
      })

    return this._loadingDialog(
      this.$mdDialog,
      promise,
      this.$document,
      ".user-profile .add-password-form",
    )
  }

  resetUpdatePasswordForm(form: any) {
    this.oldPassword = ""
    this.newPassword = ""
    this.showNewPassword = false
    form.oldPassword.$setValidity("required", true)
    form.oldPassword.$setValidity("invalid-password", true)
    form.newPassword.$setValidity("required", true)
    form.$setUntouched()
    form.$setPristine()
  }

  oldPasswordUpdated(form: any) {
    form.oldPassword.$setValidity("invalid-password", true)
  }

  toggleSidenav() {
    this.$mdSidenav("nav").toggle()
  }

  resetInviteCodeForm(proInviteForm: any) {
    this._inviteCode = ""
    proInviteForm.inviteCode.$setValidity("invalid-code", true)
    proInviteForm.inviteCode.$setValidity("too-long", true)
    proInviteForm.inviteCode.$setValidity("pattern", true)
    proInviteForm.$setUntouched()
    proInviteForm.$setPristine()
    this._inviteCodeError = false
  }

  inviteCodeUpdated(proInviteForm: any) {
    proInviteForm.inviteCode.$setValidity("invalid-code", true)
    proInviteForm.inviteCode.$setValidity("too-long", true)
    proInviteForm.inviteCode.$setValidity("pattern", true)
    this._inviteCodeError = false

    this._inviteCode = this._inviteCode
      .replace(/[\\s]/g, "")
      .slice(0, 6)
      .toUpperCase()

    if (!this._inviteCode) {
      return
    }

    if (this._inviteCode.length > 5) {
      proInviteForm.inviteCode.$setValidity("too-long", false)
      this._inviteCodeError = true
    } else if (!this._inviteCodeRegex.test(this._inviteCode)) {
      proInviteForm.inviteCode.$setValidity("pattern", false)
      this._inviteCodeError = true
    }
  }

  enterProInvite(proInviteForm: any) {
    this._inviteCodeError = false
    proInviteForm.inviteCode.$setValidity("invalid-code", true)
    const promise = this._inviteCodeService
      .submit(this.inviteCode)
      .then((token) => {
        return this._authService.processTokenResult(
          token,
          this._authService.rememberMe,
        )
      })
      .then(() => {
        this._cacheService.reset()
        this.showToast("You have been added to the organization successfully!")
        this.resetInviteCodeForm(proInviteForm)
        this._updateLeftNav()
        this.$state.reload()
      })
      .catch((err) => {
        this._inviteCodeError = true
        proInviteForm.inviteCode.$setValidity("invalid-code", false)
        this.$log.error(err)
      })

    this._loadingDialog(
      this.$mdDialog,
      promise,
      this.$document,
      ".user-profile .pro-invite-form",
    )
  }

  deleteAccountDialog() {
    if (!this.user) return
    if (this.isTeacher) {
      this._deleteAccountDialog(this.$mdDialog, this.user)
    } else {
      const promise = this._studentCacheService.getUserAssignmentsAndWorks(true)

      this._loadingDialog(this.$mdDialog, promise)

      promise.then(({ works }) => {
        if (
          this._worksStarted(works) >
          DeleteAccountDialogController.AssignmentsWorkedOnThreshold
        ) {
          this._confirmDialog(
            this.$mdDialog,
            "Uh oh. It looks like you've already done quite a bit of work. If you are sure you want to delete your account, please email support@classkick.com",
            undefined,
            true,
          )
        } else {
          this._deleteAccountDialog(this.$mdDialog, this.user)
        }
      })
    }
  }

  _worksStarted(works: Map<string, any>) {
    return Array.from(works.values()).filter((work) => work.hasStarted).length
  }

  get inviteCode() {
    return this._inviteCode
  }

  set inviteCode(value: string) {
    this._inviteCode = value
  }

  get inviteCodeError() {
    return this._inviteCodeError
  }

  get emailError() {
    return this._emailError
  }

  get usernameError() {
    return this._usernameError
  }

  get inviteCodePattern() {
    return this._inviteCodePattern
  }

  _commit() {
    if (!this.user) return Promise.reject("User not loaded")

    this._usernameError = null
    this._emailError = null
    this.user.displayName = this.prefix ? `${this.prefix} ${this.lastName}` : ""
    this.user.firstName = this.firstName ?? ""
    this.user.lastName = this.lastName ?? ""
    this.user.username = this.username ?? ""
    this.user.email = this.email ?? ""
    this.user.jobTitle = this.jobTitle ?? ""
    this.user.referral = this.referral ?? ""
    this.user.studentAge = this.studentAge ?? ""
    this.user.subject = this.subject ?? ""

    return this._cacheService
      .updateUser(this.user)
      .then(() => {
        this.saveState = SaveStates.SAVED
        this._updateLeftNav()
      })
      .catch((err) => {
        if (err.data && err.data.message) {
          if (err.data.message.indexOf("Duplicate entry") !== -1) {
            this._emailError = "Email is already in use"
          } else if (err.data.message.indexOf("well-formed") !== -1) {
            this._emailError = "Not a valid email address"
          }
        }
        this.$log.error(err)
        this.saveState = SaveStates.SAVE_ERROR
      })
  }

  get SAVED() {
    return SaveStates.SAVED
  }

  get UNSAVED() {
    return SaveStates.UNSAVED
  }

  get SAVE_ERROR() {
    return SaveStates.SAVE_ERROR
  }

  autocompleteFilter(search: string, array: string[]) {
    if (!search) {
      return array
    }
    return array.filter((value) =>
      value.toLowerCase().includes(search.toLowerCase()),
    )
  }

  get isTeacher() {
    return this._authService.authData && this._authService.authData.isTeacher
  }

  get isStudent() {
    return this._authService.authData && this._authService.authData.isStudent
  }

  get isPasswordAuthed() {
    return this.user?.authTypes.includes(AuthType.PASSWORD) || false
  }

  get isGoogleAuthed() {
    return this.user?.authTypes.includes(AuthType.GOOGLE) || false
  }

  get isCleverAuthed() {
    return this.user?.authTypes.includes(AuthType.CLEVER) || false
  }

  get isCleverImported() {
    return this.user?.authTypes.includes(AuthType.CLEVERIMPORT) || false
  }

  get addedNewPassword() {
    return this._addedNewPassword
  }

  set addedNewPassword(value: boolean) {
    this._addedNewPassword = value
  }

  _destroy() {
    this._debouncer.destroy()
  }

  showToast(message: string) {
    this.$mdToast.show(
      this.$mdToast.simple().textContent(message).position("bottom right"),
    )
  }

  _updateLeftNav() {
    this.$rootScope.$broadcast(NavController.UPDATE_LEFT_NAV, {})
  }

  _getAdminsForSchools(schools: Organization[]): SchoolWithAdmins[] {
    schools.sort((a, b) => Sorts.NAME_ASC(a.name, b.name))

    return schools.map((school) => {
      const schoolWithAdmins: SchoolWithAdmins = school
      if (schoolWithAdmins.contractId) {
        this._cacheService
          .getUsersForContract(schoolWithAdmins.contractId)
          .then((users: Map<string, User>) => {
            return Array.from(users.values()).filter((user) => {
              return (
                Array.isArray(user.contractMembers) &&
                user.contractMembers.length > 0 &&
                typeof user.contractMembers[0] === "object" &&
                "admin" in user.contractMembers[0] &&
                (user.contractMembers[0] as { admin?: boolean }).admin === true
              )
            })
          })
          .then((admins) => {
            schoolWithAdmins.adminMembers = admins
          })
      }
      return schoolWithAdmins
    })
  }

  removeSelfFromOrganization(organizationId: string) {
    this._organizationService
      .removeSelf(organizationId)
      .then(() =>
        this._cacheService
          .getSchools(true)
          .then(
            (schools: Organization[]) =>
              (this._schools = this._getAdminsForSchools(schools)),
          )
          .then(() =>
            this._cacheService.getProInfo(true).then((proInfo) => {
              this._contracts = proInfo.contracts
              this.$state.reload()
            }),
          ),
      )
      .catch(() => {
        this.saveState = SaveStates.SAVE_ERROR
      })
  }

  addSelfToOrganization() {
    ;(
      this._updateUserSchoolDialog(
        this.$mdDialog,
        "Join Organization",
      ) as Promise<Organization>
    ).then((school: Organization) => this._addSelfToOrganization(school))
  }

  _addSelfToOrganization(school: Organization) {
    this.saveState = SaveStates.UNSAVED

    const promise = this._organizationService
      .addSelf(school.id)
      .then((token) => {
        this._cacheService.reset()
        return this._authService.processTokenResult(
          token,
          this._authService.rememberMe,
        )
      })
      .then(() => {
        this.$state.reload()
      })
      .catch(() => {
        this.saveState = SaveStates.SAVE_ERROR
      })

    this._loadingDialog(this.$mdDialog, promise)
  }

  displayAdminTitle(admins: User[]) {
    if (admins?.length) {
      return admins.length === 1 ? "Admin" : "Admins"
    } else {
      return "No Admins"
    }
  }

  get unverifiedSchools() {
    return this._unverifiedSchools
  }

  schoolIsUnverified(school: Organization) {
    return !!this.unverifiedSchools?.get(school.id)
  }

  showVerifyMdr(school: Organization) {
    if (!this.unverifiedSchools || !this.user) return
    this._mdrOrgDialog(
      this.$mdDialog,
      school,
      this.unverifiedSchools,
      this.user.id,
      true,
    ).then((schoolWasVerified: boolean) => {
      if (schoolWasVerified) {
        this.unverifiedSchools?.delete(school.id)
      }
    })
  }

  goToOrderPage() {
    this._staticContentService.goToOrdersPage(
      this._logRocketService.initialized,
    )
  }

  goToStudentWorkPage() {
    this._staticContentService.goToStudentWorkPage()
  }

  showAddPassword() {
    return !!(
      !this.isPasswordAuthed &&
      this.isTeacher &&
      !this.addedNewPassword &&
      this.user?.email
    )
  }

  isACoTeacher() {
    return this._authService.isACoTeacher()
  }
}
